"use server";

import type { ReactNode } from "react";
import { setRequestLocale } from "next-intl/server";
import { locales } from "@/i18n/locales";
import { getSettingNumber } from "@/modules/settings";
import { FeedRow } from "./feed-row";
import { parseListQuery } from "./parse-list-query";
import { resolvePostList } from "./resolve-post-list";

/** The next page of the news feed as rows, for the reader who scrolled to the end; `done` says there is nothing after it. The filters come from the address and are checked like it. */
export async function loadFeedPageAction(locale: string, search: Record<string, string>, page: number): Promise<{ rows: ReactNode; done: boolean }> {
  if (!locales.includes(locale)) return { rows: null, done: true };
  setRequestLocale(locale);
  const query = parseListQuery({ ...search, page: String(page) });
  const [{ cards, total }, size] = await Promise.all([resolvePostList(locale, query), getSettingNumber("blog.pageSize")]);
  return { rows: cards.map((card) => <FeedRow key={card.itemId} card={card} />), done: query.page * size >= total };
}
